import {Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {BranchCommissionGrid} from "./grid";
import {getAgentBranchCommissions} from "../../services/branch_commission/branch_commission";
import {CardFooterPaginator} from "../system/cardFooterPaginator";


export function AgentBranchCommissionManagement() {

    const [branchCommissions, setBranchCommissions] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [gridRowCount, setGridRowCount] = useState(5);
    const [gridCurrentPage, setGridCurrentPage] = useState(1);
    const [gridSelectedRow, setGridSelectedRow] = useState(null);
    const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
    const [sortBy, setSortBy] = useState("id")
    const [sortType, setSortType] = useState(false);
    const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
    const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
    const [lastDataRefresh, setLastDataRefresh] = useState(null);

    useEffect(() => {
        if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
            setTo((gridCurrentPage) * gridRowCount)
        } else {
            setTo(gridTotalRowCount)
        }
        if (gridTotalRowCount === 0) {
            setFrom(0)
        } else {
            setFrom((gridCurrentPage - 1) * gridRowCount + 1)
        }
    }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

    async function getData(paginate) {
        const result = await getAgentBranchCommissions(paginate);
        if (result.status === 200) {
            const {branchCommissionList, total_count} = result.data;
            setBranchCommissions(branchCommissionList || []);
            setGridTotalRowCount(total_count);
        }
    }

    useEffect(() => {
        const paginate = new URLSearchParams({
            "sort_by": sortBy,
            "sort_type": sortType === false ? "DESC" : "ASC",
            "limit": parseInt(gridRowCount),
            "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
        }).toString()

        getData(paginate)
    }, [lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

    return (
        <div className="">
            <Card className="pt-8">
                <CardHeader floated={true} shadow={false} className="rounded-none">
                    <div className="mb-8 flex items-center justify-between gap-8">
                        <Typography variant="h5" color="blue-gray">کمیسیون سرویس‌ها</Typography>
                    </div>
                </CardHeader>
                <CardBody className="overflow-x-auto w-full">
                    <BranchCommissionGrid
                        BranchCommissions={branchCommissions}
                        setModalOpen={setModalOpen}
                        setSelectedRow={setGridSelectedRow}
                        setSortBy={setSortBy}
                        sortType={sortType}
                        setSortType={setSortType}
                    />
                </CardBody>
                <CardFooterPaginator
                    active={gridCurrentPage}
                    setActive={setGridCurrentPage}
                    totalRows={gridTotalRowCount}
                    rowsCount={gridRowCount}
                    setRowsCount={setGridRowCount}
                    from={from}
                    to={to}
                />
            </Card>
        </div>
    );
}